import React, { useMemo, useState } from 'react';
import Modal from '../../../Atoms/Modal/Modal';
import styles from './Settings.module.scss';

const CheckIcon = () => (
  <svg width='16' height='16' viewBox='0 0 20 20' fill='none'>
    <path
      d='M16.667 5L7.5 14.167 3.333 10'
      stroke='white'
      strokeWidth='2.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const Settings = ({
  years = [],
  onSetDefaultYear,
  isLoading = false,
  onSuccess,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const defaultId = useMemo(
    () => years.find((y) => y.isDefault)?.id ?? null,
    [years]
  );

  const [selectedId, setSelectedId] = useState(defaultId);

  const open = () => {
    setSelectedId(defaultId);
    setIsOpen(true);
  };

  const close = () => {
    if (isLoading) return;
    setIsOpen(false);
  };

  const handleConfirm = () => {
    if (!selectedId) return;
    if (selectedId === defaultId) return;

    onSetDefaultYear?.(selectedId, () => {
      setIsOpen(false);
      onSuccess?.();
    });
  };

  return (
    <>
      <button type='button' className={styles.settingsBtn} onClick={open}>
        <img src='/icons/settings.svg' alt='الإعدادات' />
      </button>

      {isOpen && (
        <Modal
          title='السنوات الأكاديمية'
          onClose={close}
          innerContainerClass={styles.modal}
        >
          <div className={styles.wrapper}>
            <div className={styles.list}>
              {years.map((year) => {
                const isSelected = year.id === selectedId;
                const isDefault = year.id === defaultId;

                return (
                  <button
                    key={year.id}
                    type='button'
                    className={`${styles.row} ${
                      isSelected ? styles.rowSelected : ''
                    }`}
                    onClick={() => setSelectedId(year.id)}
                  >
                    {isSelected ? (
                      <span className={styles.badge}>
                        <span className={styles.badgeIcon}>
                          <CheckIcon />
                        </span>
                        الافتراضي
                      </span>
                    ) : (
                      <span className={styles.badgePlaceholder} />
                    )}

                    <span className={styles.content}>
                      <span className={styles.top}>
                        <span className={styles.yearLabel}>{year.label}</span>

                        <img
                          src={
                            isSelected
                              ? '/icons/star.svg'
                              : '/icons/empty-star.svg'
                          }
                          alt=''
                          className={styles.star}
                        />
                      </span>

                      <span className={styles.meta}>
                        {year.count ?? 0} فعالية •{' '}
                        {year.hasPoster ? 'تم رفع الملصق' : 'لا يوجد ملصق'}
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>

            <div className={styles.actions}>
              <button
                type='button'
                className={`${styles.actionBtn} ${styles.cancel}`}
                onClick={close}
                disabled={isLoading}
              >
                إلغاء
              </button>

              <button
                type='button'
                className={`${styles.actionBtn} ${styles.primary}`}
                onClick={handleConfirm}
                disabled={isLoading || !selectedId || selectedId === defaultId}
              >
                {isLoading ? 'جارٍ الحفظ...' : 'تعيين كافتراضي'}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Settings;
